module.exports = __webpack_public_path__ + "static/media/logo192.3f136cc4.png";